export default {
	lang: 'th',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav":"วอร์มอร์ เอไอ",
		"nav2":"ความปลอดภัยของบัญชี",
		"nav3":"คลาวด์ดิสก์ของฉัน",
		"nav4":"ออกจากระบบ",
		"nav5":"เข้าสู่ระบบ",
		"nav6":"คลาวด์สเปซ",
		"nav7":"ChatGPT โมเดลขนาดใหญ่",
		"nav8":"ระบบบันทึกเสียงอัจฉริยะ Cloud Space",
		"nav_phone_number_code":'หมายเลขโทรศัพท์มือถือ',
		"nav_update":'เปลี่ยน',
		"nav_bind":'ผูกพัน',
		"nav_phone_code_tips":'เพื่อยืนยันว่าคุณเป็นผู้ดำเนินการ กรุณากรอกรหัสยืนยันผ่านโทรศัพท์มือถือเพื่อดำเนินการยืนยันตัวตน',
		"nav_phone_number":'หมายเลขโทรศัพท์มือถือ',
		"nav_phone_number_verify":'เปลี่ยนการยืนยันหมายเลขโทรศัพท์',
		"nav_phone_email_verify":'สลับการยืนยันอีเมล',
		"nav_set_phone_number": 'ตั้งค่าหมายเลขโทรศัพท์ใหม่',
		"nav_verify_login":'ยืนยันการเข้าสู่ระบบ',
		"nav_phone_email":'อีเมล/หมายเลขโทรศัพท์',
		"nav_phone_login":'เข้าสู่ระบบด้วยการยืนยันโทรศัพท์',
		"nav_email_login":'เข้าสู่ระบบด้วยการยืนยันอีเมล',
		"nav_email_fail":'รูปแบบอีเมลผิดพลาด โปรดป้อนใหม่',
		"nav_pw_fail":'รูปแบบรหัสผ่านผิดพลาด โปรดป้อนใหม่',
		"nav_code_fail":'รหัสยืนยันผิด',
		"nav_phone_fail":'รูปแบบหมายเลขโทรศัพท์ผิดพลาด โปรดป้อนใหม่',
		"nav_input_fail":'กรุณากรอกอีเมล',
		"nav_input_phone":'กรุณาป้อนหมายเลขโทรศัพท์',
		"nav_phone_verify_back":'กู้คืนด้วยการยืนยันหมายเลขโทรศัพท์',
		"nav_email_verify_back": "กู้คืนด้วยการยืนยันอีเมล"
	},
	login: {
		"login1":"รหัสผ่านเข้าระบบ",
		"login2":"เข้าสู่ระบบ SMS",
		"loginTab3":"เข้าสู่ระบบอีเมล์",
		"login3":"จดหมาย",
		"login4":"รหัสผ่านในการเข้าสู่ระบบ",
		"login5":"เบอร์โทรศัพท์",
		"login6":"กรุณาเลือก",
		"login7":"รหัสยืนยันมือถือ",
		"login8":"เข้าสู่ระบบ",
		"login9":"ลืมรหัสผ่าน",
		"login10":"ลงทะเบียน",
		"login11":"โดยการเข้าสู่ระบบ คุณยอมรับ",
		"login12":"ข้อตกลงการให้บริการ",
		"login13":"นโยบายความเป็นส่วนตัว",
		"login14":"รับ",
		"login15":"จีน",
		"login16":"กรุณากรอกหมายเลขบัญชีของคุณ",
		"login17":"กรุณากรอกรหัสผ่านของคุณ",
		"login18":"เข้าสู่ระบบสำเร็จ!",
		"login19":"กรุณากรอกรหัสยืนยัน!",
		"login20":"ส่งเรียบร้อยแล้ว!",
		"login21":"และ",
		"login22":"คลาวด์ดิสก์บันทึกเสียง",
		"login23":"การเขียนของฉัน",
		"login24":"บทสนทนาของฉัน",
		"login25":"ความปลอดภัยของบัญชี",
		"login26":"ออกจากระบบ",
		"login27":"กู้คืนรหัสผ่านทางอีเมล",
		"login28":"จดหมาย",
		"login29":"รหัสยืนยันอีเมล",
		"login30":"ตั้งรหัสผ่านในการเข้าสู่ระบบ (6-16 ตัวอักษร)",
		"login31":"กรอกรหัสผ่านในการเข้าสู่ระบบอีกครั้ง",
		"login32":"ส่ง",
		"login33":"กลับสู่การเข้าสู่ระบบ",
		"login34":"การแก้ไขสำเร็จแล้ว!",
	},
	register: {
		"register1":"เบอร์โทรศัพท์",
		"register2":"กรุณากรอกเบอร์โทรศัพท์ของท่าน",
		"register3":"กรุณาเลือก",
		"register4":"รหัสยืนยันมือถือ",
		"register5":"ตั้งรหัสผ่าน",
		"register6":"กรุณากรอกรหัสยืนยัน",
		"register7":"6-16 ตัวอักษร",
		"register8":"การยืนยันรหัสผ่าน",
		"register9":"จดหมาย",
		"register10":"กรุณากรอกที่อยู่อีเมล์ของคุณ",
		"register11":"รหัสยืนยันอีเมล",
		"register12":"กรุณากรอกรหัสยืนยัน",
		"register13":"ฉันได้อ่านแล้วและเห็นด้วย",
		"register14":"กรุณาอ่านและทำเครื่องหมายในช่องที่ยอมรับข้อตกลง",
		"register15":"รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง/หมายเลขโทรศัพท์ได้รับการลงทะเบียนแล้ว",
		"register16":"ข้อผิดพลาดรหัสยืนยันมือถือ",
		"register17":"กรุณากรอกที่อยู่อีเมลของคุณ / รูปแบบที่อยู่อีเมลไม่ถูกต้อง",
		"register18":"ข้อผิดพลาดรูปแบบอีเมล",
		"register19":"ข้อผิดพลาดรหัสยืนยันอีเมล",
		"register20":"กรุณาตั้งรหัสผ่านเป็น 6-16 ตัวอักษร",
		"register21":"ข้อผิดพลาดรูปแบบรหัสผ่าน",
		"register22":"รหัสผ่านที่คุณป้อนสองครั้งไม่ตรงกัน กรุณาป้อนใหม่อีกครั้ง",
		"register23":"กรุณากรอกรหัสผ่านของคุณ",
		"register24":"ลงทะเบียนสำเร็จ!",
		"register25":"รหัสตรวจสอบมีข้อผิดพลาด",
	},
	recorder:{
		"recorder1":"คลาวด์ดิสก์บันทึกเสียง",
		"recorder2":"ความจุพื้นที่คลาวด์",
		"recorder3":"เอกสาร",
		"recorder331":"ถังขยะรีไซเคิล",
		"recorder332":"ล้างทั้งหมด",
		"recorder4":"ชื่อ",
		"recorder5":"ระยะเวลาของเสียง",
		"recorder6":"ขนาดไฟล์",
		"recorder7":"เวลาการสร้าง",
		"recorder8":"ดำเนินงาน",
		"recorder9":"คำอธิบายพื้นที่คลาวด์",
		"recorder10":"เอกสาร",
		"recorder11":"ไฟล์ OCR",
		"recorder12": '1. การใช้งานพื้นที่คลาวด์',
		"recorder13":'หลังจากบันทึกเสียงหรือจดบันทึกด้วยลายมือบนสมาร์ทโน้ตบุ๊คหรือเครื่องบันทึกเสียง คุณสามารถอัปโหลดไฟล์ไปยังคลาวด์ได้ แม้จะไม่มีอุปกรณ์สมาร์ทติดตัว คุณก็ยังสามารถเข้าถึงไฟล์บันทึกในพื้นที่คลาวด์ได้',
		"recorder14": '2. วิธีอัปโหลดไปยังพื้นที่คลาวด์?',
		"recorder15": 'เครื่องบันทึกเสียง: เข้าไปที่อุปกรณ์【ไฟล์ของฉัน】→ คลิกดำเนินการแบบกลุ่ม → คลิก "อัปโหลด" เพื่อเพิ่มไฟล์เข้าคิวอัปโหลดไปยังพื้นที่คลาวด์',
		"recorder16": "สมุดบันทึกอัจฉริยะ:",
		"recorder17": 'วิธีที่หนึ่ง: กดค้างบนรายการบันทึก เพื่อเลือกบันทึกที่ต้องการอัปโหลดเป็นกลุ่ม → คลิก "ซิงค์" เพื่อดำเนินการอัปโหลด',
		"recorder171": 'วิธีที่สอง: เปิดหน้ารายละเอียดบันทึกเดี่ยว → คลิก【เพิ่มเติม - ซิงค์】 เพื่ออัปโหลดบันทึกนั้นไปยังคลาวด์สเปซ',
		"recorder18":"ไม่ได้ถอดความ",
		"recorder19":"ดูสรุป",
		"recorder20":"ผู้บรรยาย",
		"recorder21":"แก้ไขชื่อผู้พูด",
		"recorder22":"แน่นอน",
		"recorder23":"ดาวน์โหลด",
		"recorder24":"ดาวน์โหลดเนื้อหา:",
		"recorder25":"การตั้งค่าการดาวน์โหลด:",
		"recorder26":"การแสดงของวิทยากร",
		"recorder27":"ยกเลิก",
		"recorder28":"การแชร์ลิงค์",
		"recorder29":"ใครก็ตามที่ได้รับลิงก์นี้สามารถเข้าถึงได้ ลิงก์นี้ใช้สำหรับอ่านเท่านั้น และมีอายุ 7 วัน",
		"recorder30":"คัดลอกลิงค์",
		"recorder31":"สแกนและดูอย่างรวดเร็ว",
		"recorder32":"องค์กรอัจฉริยะ",
		"recorder33":"การแยกความแตกต่างระหว่างลำโพง",
		"recorder34":"แยกแยะข้อความที่ถอดความอย่างชาญฉลาดตามบทบาทของผู้พูด",
		"recorder35":"การปรับมาตรฐานภาษาพูดอัจฉริยะ",
		"recorder36":"กรองอนุภาคโหมด คำที่ซ้ำ และคำที่หยุดชั่วคราวโดยอัตโนมัติ",
		"recorder37":"การกรองเสียงที่ไม่ใช่เสียงพูด",
		"recorder38":"ข้ามเสียงโดยอัตโนมัติโดยไม่มีเสียงหรือเสียงรบกวนระหว่างการเล่น",
		"recorder39":"กรุณาเลือก",
		"recorder40":"เอกสาร",
		"recorder41":"เสียง",
		"recorder42":"เอกสาร + เสียง",
		"recorder43":"คำใบ้",
		"recorder44":"การดำเนินการนี้จะลบไฟล์ คุณต้องการดำเนินการต่อหรือไม่?",
		"recorder441":"การดำเนินการนี้จะลบไฟล์ทั้งหมด คุณต้องการดำเนินการต่อหรือไม่?",
		"recorder45":"แน่นอน",
		"recorder46":"ยกเลิก",
		"recorder47":"ลบสำเร็จแล้ว!",
		"recorder48":"ยังไม่ได้ลบ",
		"recorder49":"ยังไม่มีแท็ก",
		"recorder50":"ประหยัด...",
		"recorder51":"ถังขยะรีไซเคิล",
	},
	personal: {
		"personal1":"การตั้งค่าบัญชี",
		"personal2":"ข้อมูลส่วนตัว",
		"personal3":"อวาตาร์",
		"personal4":"อัพโหลดไฟล์",
		"personal5":"รองรับรูปแบบ JPG, JPEG, GIF, PNG รองรับรูปภาพขนาดไม่เกิน 2M",
		"personal6":"ชื่อเล่น",
		"personal7":"กรุณากรอกชื่อเล่นของคุณ",
		"personal8":"เพศ",
		"personal9":"สุภาพบุรุษ",
		"personal10":"นางสาว",
		"personal11":"ความลับ",
		"personal12":"วันเกิด",
		"personal13":"กรุณาเลือกวันเกิดของคุณ",
		"personal14":"วิชาชีพ",
		"personal15":"กรุณาเลือกอาชีพของคุณ",
		"personal16":"กรุณาระบุอาชีพของคุณ (ไม่บังคับ)",
		"personal17":"ชาติ",
		"personal18":"กรุณาเลือกประเทศของคุณ",
		"personal19":"เก็บ",
		"personal20":"ข้อมูลส่วนตัว",
		"personal21":"ความปลอดภัยของบัญชี",
		"personal22":"รองรับเฉพาะรูปภาพที่มีขนาดไม่เกิน 2 ล้าน",
		"personal23":"อัพโหลดสำเร็จแล้ว!",
		"personal24":"การแก้ไขสำเร็จแล้ว!",
		"personal25":"ความปลอดภัยของบัญชี",
		"personal26":"รหัสผ่านในการเข้าสู่ระบบ",
		"personal27":"ปรับปรุงใหม่",
		"personal28":"อีเมล",
		"personal29":"แทนที่",
		"personal30":"การยกเลิกบัญชี",
		"personal32":"คุณแน่ใจว่าต้องการยกเลิกบัญชีของคุณหรือไม่?",
		"personal33":"หลังจากออกจากระบบ เนื้อหาทั้งหมดในบัญชีของคุณจะถูกล้าง ดังนั้นโปรดดำเนินการด้วยความระมัดระวัง",
		"personal34":"ยกเลิก",
		"personal35":"แน่นอน",
		"personal36":"การตรวจสอบความถูกต้อง",
		"personal37":"เพื่อยืนยันว่าคุณเป็นผู้ดำเนินการนี้ โปรดทำการยืนยันตัวตนผ่านรหัสยืนยันอีเมล",
		"personal38":"จดหมาย",
		"personal39":"รหัสยืนยัน",
		"personal40":"กรุณากรอกรหัสยืนยัน",
		"personal41":"ขั้นตอนต่อไป",
		"personal42":"ตั้งค่ากล่องจดหมายใหม่",
		"personal43":"จดหมาย",
		"personal44":"กรุณากรอกอีเมลใหม่",
		"personal45":"รหัสยืนยัน",
		"personal46":"กรุณากรอกรหัสยืนยัน",
		"personal47":"แน่นอน",
		"personal48":"ตั้งรหัสผ่านเข้าสู่ระบบใหม่",
		"personal49":"รหัสผ่านเข้าสู่ระบบใหม่",
		"personal50":"กรุณากรอกรหัสผ่านใหม่",
		"personal51":"ยืนยันรหัสผ่านใหม่",
		"personal52":"กรุณากรอกรหัสผ่านใหม่อีกครั้ง",
		"personal53":"แน่นอน",
		"personal54":"รับ",
		"personal55":"ข้อผิดพลาดรูปแบบอีเมล",
		"personal56":"การเปลี่ยนสำเร็จแล้ว!",
		"personal57":"กรุณาตั้งรหัสผ่านเป็น 6-16 ตัวอักษร",
		"personal58":"รหัสผ่านที่คุณป้อนสองครั้งไม่ตรงกัน",
		"personal59":"การแก้ไขสำเร็จแล้ว!",
		"personal60":"ออกจากระบบสำเร็จ!",
		
		"share_url": "การแชร์ลิงก์",
		"share_url_7_day": "ลิงก์สำหรับแชร์มีอายุการใช้งาน 7 วัน ใครก็ตามที่ได้รับลิงก์จะสามารถเข้าถึงได้ก่อนหมดอายุ",
		"share_audio": "การบันทึกเสียง",
		"share_trans_text": "การถอดเสียง",
		"share_summny_text": "สรุป",
		"share_map": "แผนผังความคิด",
		"share_url_pw": "การเข้ารหัสการเข้าถึง",
		"share_random_pw": "รหัสผ่านแบบสุ่ม",
		"share_url_copy": "คัดลอกลิงก์",
		"share_url_copy_success": "คัดลอกลิงก์สำเร็จ",
		"share_link_pw": "รหัสผ่านการเข้าถึง",
		"share_copy_success": "การถอดเสียงได้รับการคัดลอกไปยังคลิปบอร์ดแล้ว!",
		"share_copy_success2": "คัดลอกเนื้อหาสรุปไปยังแผ่นตัดแล้ว!",
		"share_speaker": "ผู้พูด",
		"share_no_update_speaker": "ไม่สามารถแก้ไขผู้พูดได้ ลำโพงว่างเปล่า",
		"share_no_trans":"ไม่ การถอดเสียง",
		"share_no_summny":"ไม่มีสรุป",
		"share_no_map":"ไม่มีเนื้อหาแผนที่",
		"share_trans_text_1": "การถอดเสียง",
		"share_summny_text_1": "สรุป",
		"share_map_1": "แผนที่",
		"share_save": "บันทึกสำเร็จ",
		"share_no_map":"ไม่ได้สร้างภาพแผนที่",
		"share_update_text": "แก้ไขข้อความถอดเสียง",
		"share_update_text2": "แก้ไขข้อความสรุป",
		"showLoading": "กำลังโหลด...",
		"handwriting": "เนื้อหาที่เขียนด้วยลายมือ",
		"handwritingText": "การเขียนด้วยลายมือ",
		"share_1": "ระบบไม่รู้จักเนื้อหาลายมือในหน้านี้",
		"share_2": "แก้ไขระบบจดจำลายมือ",
		"share_3": "ระบบจดจำลายมือ",
		"share_4":"กำลังส่งออกไฟล์อย่าออกจากหน้านี้",
		"folder_text":"โฟลเดอร์",
		"folder_text_update_name":"เปลี่ยนชื่อ",
		"folder_text_del":"ลบ",
		"folder_text_all":"ทั้งหมด",
		"folder_text_type":"ประเภทไฟล์",
		"folder_text_audio":"บันทึกเสียง",
		"folder_text_writing":"บันทึกย่อที่เขียนด้วยลายมือ",
		"folder_text_file_type":"ประเภทไฟล์",
		"folder_text_add":"สร้างโฟลเดอร์ใหม่",
		"folder_text_input_name":"กรุณาใส่ชื่อ",
		"folder_text_cancel":"ยกเลิก",
		"folder_text_summit":"ยืนยัน",
		"folder_text_name_not_null":"ชื่อต้องไม่ว่างเปล่า",
		"folder_text_add_success":"สร้างสำเร็จแล้ว!",
		"folder_text_del_confirm":"ยืนยันการลบแล้ว",
		"folder_text_confirm":"คุณแน่ใจหรือไม่ว่าต้องการลบโฟลเดอร์ที่เลือก? บันทึกย่อในโฟลเดอร์จะถูกย้ายไปยังถังขยะหลังจากการลบ",
		"folder_text_del_success":"ลบสำเร็จแล้ว!",
		"folder_text_move":"ย้ายไปที่",
		"folder_text_move_success":"ย้ายสำเร็จแล้ว!",
		"folder_update_name":"เปลี่ยนชื่อโฟลเดอร์",
		"folder_text_update_success":"แก้ไขสำเร็จแล้ว!",
		"empty_text":"ไม่มีข้อมูลที่มีอยู่",
		"trans_text_null":"ข้อความที่ถอดเสียงต้องไม่ว่างเปล่า",
		"summary_text_null":"สรุปต้องไม่ว่างเปล่า",
		"please_create_folder":"โปรดสร้างโฟลเดอร์ก่อน"
	}
}